import Vue from 'vue'
import Router from 'vue-router'

import index from '@/components/index'

//news
import news_index from '@/components/news_index'
import news_show from '@/components/news_show'

//players
import players_index from '@/components/players_index'
import players_show from '@/components/players_show'

//works
import program_index from '@/components/program_index'
import program_show from '@/components/program_show'
import drawn_index from '@/components/drawn_index'
import drawn_show from '@/components/drawn_show'
import event_index from '@/components/event_index'
import event_show from '@/components/event_show'
import photographing_index from '@/components/photographing_index'
import vp_cm_index from '@/components/vp_cm_index'
import vp_cm_show from '@/components/vp_cm_show'
import archive_index from '@/components/archive_index'

//tapcst
import tapcast_index from '@/components/tapcast_index'
// import tapcast_show from '@/components/tapcast_show'

//magic
import magic_index from '@/components/magic_index'
import magic_show from '@/components/magic_show'

//company
import company_index from '@/components/company_index'
import history_index from '@/components/history_index'
import awards_index from '@/components/awards_index'
import sustainability_index from '@/components/sustainability_index'
import vivia_index from '@/components/vivia_index'

//recruit
import recruit_index from '@/components/recruit_index'
import recruit_requirements from '@/components/recruit_requirements'
import recruit_2021 from '@/components/recruit_2021'
import recruit_2022 from '@/components/recruit_2022'
import recruit_2023 from '@/components/recruit_2023'
import recruit_2024 from '@/components/recruit_2024'
import recruit_2025_redirect from '@/components/recruit_2025_redirect'
import recruit_2026_redirect from '@/components/recruit_2026_redirect'
import recruit_2027_top from '@/components/recruit_2025_top'
import recruit_2025_teaser from '@/components/recruit_2025_teaser'
import recruit_2027_application from '@/components/recruit_2025_application'

//creator_bank
import creator_bank_contact from '@/components/creator_bank_contact'

//comp
import finance_index from '@/components/finance_index'

//contact
import contact from '@/components/contact'

//privacypolicy
import privacypolicy from '@/components/privacypolicy'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'index',
      component: index,
      meta: { title: 'TOPページ'}
    },
    {
      path: '/news',
      name: 'news_index',
      component: news_index,
      meta: { title: 'NEWS'}
    },
    {
      path: '/news/:id(\\d+)',
      name: 'news_show',
      props: true,
      component: news_show,
      meta: { title: 'NEWS'}
    },
    {
      path: '/players',
      name: 'players_index',
      component: players_index,
      meta: { title: 'PLAYers'}
    },
    {
      path: '/players/:id(\\d+)',
      name: 'players_show',
      props: true,
      component: players_show,
      meta: { title: 'PLAYers'}
    },
    {
      path: '/works',
      name: 'program_index',
      component: program_index,
      meta: { title: '制作実績'}
    },
    {
      path: '/works/:id(\\d+)',
      name: 'works_program_show',
      props: true,
      component: program_show,
      meta: { title: '制作実績'}
    },
    {
      path: '/works/drawn',
      name: 'drawn_index',
      component: drawn_index,
      meta: { title: 'ドローン事業'}
    },
    {
      path: '/works/drawn/:id(\\d+)',
      name: 'drawn_show',
      props: true,
      component: drawn_show,
      meta: { title: 'ドローン事業'}
    },
    {
      path: '/works/event/',
      name: 'event_index',
      component: event_index,
      meta: { title: 'イベント'}
    },
    {
      path: '/works/event/:id(\\d+)',
      name: 'event_show',
      props: true,
      component: event_show,
      meta: { title: 'イベント'}
    },
    {
      path: '/works/photographing/',
      name: 'photographing_index',
      component: photographing_index,
      meta: { title: '撮影・編集'}
    },
    {
      path: '/works/vp_cm/',
      name: 'vp_cm_index',
      component: vp_cm_index,
      meta: { title: 'PR・CM'}
    },
    {
      path: '/works/vp_cm/:id(\\d+)',
      name: 'vp_cm_show',
      props: true,
      component: vp_cm_show,
      meta: { title: 'PR・CM'}
    },
    {
      path: '/works/magic',
      name: 'magic_index',
      component: magic_index,
      meta: { title: 'MAGIC'}
    },
    {
      path: '/works/magic/:id(\\d+)',
      name: 'magic_show',
      component: magic_show,
      meta: { title: 'MAGIC'}
    },
    {
      path: '/works/video-archive/',
      name: 'video-archive_index',
      component: archive_index,
      meta: { title: 'テレビ朝日映像アーカイブ'}
    },
    {
      path: '/tapcast',
      name: 'tapcast_index',
      component: tapcast_index,
      meta: { title: 'TAPキャスト'}
    },
    // {
    //   path: '/tapcast/:id(\\d+)',
    //   name: 'tapcast_show',
    //   component: tapcast_show,
    //   meta: { title: 'TAPキャスト'}
    // },
    {
      path: '/company',
      name: 'company_index',
      component: company_index,
      meta: { title: '会社概要'}
    },
    {
      path: '/company/history/',
      name: 'history_index',
      component: history_index,
      meta: { title: '沿革'}
    },
    {
      path: '/company/awards/',
      name: 'awards_index',
      component: awards_index,
      meta: { title: '受賞歴'}
    },
    {
      path: '/company/sustainability/',
      name: 'sustainability_index',
      component: sustainability_index,
      meta: { title: 'サスティナビリティ'}
    },
    {
      path: '/company/vivia/',
      name: 'vivia_index',
      component: vivia_index,
      meta: { title: 'viviaについて'}
    },
    {
      path: '/recruit/',
      name: 'recruit_index',
      component: recruit_index,
      meta: { title: '採用情報'}
    },
    {
      path: '/recruit/requirements/',
      name: 'recruit_requirements',
      component: recruit_requirements,
      meta: { title: '応募要項'}
    },
    {
      path: '/recruit_2021/',
      name: 'recruit_2021',
      component: recruit_2021,
      meta: { title: 'テレビ朝日映像新卒リクルートサイト2021'}
    },
    {
      path: '/recruit_2022/',
      name: 'recruit_2022',
      component: recruit_2022,
      meta: { title: 'テレビ朝日映像新卒リクルートサイト2022'}
    },
    {
      path: '/recruit_2023/',
      name: 'recruit_2023',
      component: recruit_2023,
      meta: { title: 'テレビ朝日映像新卒リクルートサイト2023'}
    },
    {
      path: '/recruit_2024/',
      name: 'recruit_2024',
      component: recruit_2024,
      meta: { title: 'テレビ朝日映像新卒リクルートサイト2024'}
    },
    {
      path: '/recruit_2025/',
      name: 'recruit_2025',
      component: recruit_2025_redirect,
      meta: { title: 'テレビ朝日映像新卒リクルートサイト2025'}
    },
    {
      path: '/recruit_2026/',
      name: 'recruit_2026',
      component: recruit_2026_redirect,
      meta: { title: 'テレビ朝日映像新卒リクルートサイト2026'}
    },
    {
      path: '/recruit_2027/',
      name: 'recruit_2027',
      component: recruit_2027_top,
      meta: { title: 'テレビ朝日映像新卒リクルートサイト2027'}
    },
    {
      path: '/recruit_2025_teaser/',
      name: 'recruit_2025_teaser',
      component: recruit_2025_teaser,
      meta: { title: 'テレビ朝日映像新卒リクルートサイト2025'}
    },
    {
      path: '/recruit_2027_application/',
      name: 'recruit_2027_application',
      component: recruit_2027_application,
      meta: { title: 'テレビ朝日映像新卒リクルートサイト2027'}
    },
    {
      path: '/recruit/creator_bank_contact/',
      name: 'creator_bank_contact',
      component: creator_bank_contact,
      meta: { title: 'クリエイターズバンク' }
    },
    {
      path: '/comp/',
      name: 'comp_index',
      component: finance_index,
      meta: { title: '決算公告'}
    },
    {
      path: '/contact/',
      name: 'contact',
      props: true,
      component: contact,
      meta: { title: 'お問い合わせ'}
    },
    {
      path: '/privacypolicy/',
      name: 'privacypolicy',
      component: privacypolicy,
      meta: { title: '個人情報について'}
    }
  ]
})


// WEBPACK FOOTER //
// ./src/router/index.js